'use client';

import { useState, useRef, useEffect } from 'react';

type Props = {
  onSuccess: () => void;
};

export default function PinGate({ onSuccess }: Props) {
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    const trimmed = pin.trim();
    if (!trimmed) return;
    if (trimmed.length < 4 || trimmed.length > 6) {
      setError('Enter 4–6 digits');
      setPin('');
      return;
    }
    setSubmitting(true);
    try {
      const res = await fetch('/api/auth', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pin: trimmed }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok) {
        onSuccess();
        return;
      }
      setError(data.error || 'Incorrect PIN');
      setPin('');
      inputRef.current?.focus();
    } catch {
      setError('Something went wrong');
      setPin('');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="pin-gate">
      <div className="pin-gate__card">
        <div className="pin-gate__icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
            <path d="M12 2L2 7l10 5 10-5-10-5z" />
            <path d="M2 17l10 5 10-5" />
            <path d="M2 12l10 5 10-5" />
          </svg>
        </div>
        <h1 className="pin-gate__title">Study Buddy</h1>
        <p className="pin-gate__subtitle">Enter your PIN to continue</p>
        <form onSubmit={handleSubmit} className="pin-gate__form">
          <input
            ref={inputRef}
            type="password"
            inputMode="numeric"
            autoComplete="off"
            placeholder="••••"
            className="pin-gate__input"
            value={pin}
            onChange={(e) => {
              setPin(e.target.value.replace(/\D/g, '').slice(0, 6));
              setError('');
            }}
            disabled={submitting}
            aria-label="PIN"
          />
          {error && <p className="pin-gate__error" role="alert">{error}</p>}
          <button type="submit" className="pin-gate__btn" disabled={submitting || pin.length < 4}>
            Enter
          </button>
        </form>
      </div>
    </div>
  );
}
